import { Fuel } from "lucide-react";
import { Link } from "react-router-dom";

export default function BrandHeader({ right = null }) {
  return (
    <header
      className="relative z-10 flex items-center justify-between px-4 md:px-12 py-4 md:py-5 border-b border-white/5 bg-zinc-950/80 backdrop-blur-xl"
      data-testid="brand-header"
    >
      <Link
        to="/"
        className="flex items-center gap-3 group"
        data-testid="brand-home-link"
      >
        <div className="w-9 h-9 md:w-10 md:h-10 rounded-md bg-yellow-400 flex items-center justify-center transition-transform duration-200 group-hover:-rotate-6">
          <Fuel className="w-4 h-4 md:w-5 md:h-5 text-black" strokeWidth={2.5} />
        </div>
        <div className="leading-tight">
          <div className="font-display font-black text-white tracking-tight text-base md:text-lg">
            PARAÍSO<span className="text-yellow-400">·</span>B94
          </div>
          <div className="hidden sm:block text-[10px] uppercase tracking-[0.25em] text-zinc-500 font-mono-display">
            Portal de gasolina
          </div>
        </div>
      </Link>
      <div className="flex items-center gap-2 md:gap-3">{right}</div>
    </header>
  );
}
